import React from 'react';
import { Badge, Dropdown } from '@bynder/design-system';

import { MenuItem } from '../../types';
import { navigateTo } from '../../helpers/windowLocation';

/*
 * bynder-platform/bynder/views/navigation/includes/menu.cfm
 */
export function AccountMenuItem({ item }: { item: MenuItem }) {
	const Icon = item.icon;

	if (!item.isVisible) {
		return null;
	}

	if (item.Component) {
		const Component = item.Component;

		return <Component />;
	}

	return (
		<Dropdown.Item
			onClick={() => navigateTo(item.href)}
			icon={Icon ? <Icon /> : undefined}
			badge={item.badgeLabel ? <Badge isPillShaped>{item.badgeLabel}</Badge> : undefined}
			submenu={
				item.menuItems ? (
					<>
						{item.menuItems.map((menuItem) => {
							return <AccountMenuItem item={menuItem} key={menuItem.key} />;
						})}
					</>
				) : undefined
			}
		>
			{item.label}
		</Dropdown.Item>
	);
}
